import {
  Button,
  Card,
  Col,
  Form,
  Input,
  List,
  Modal,
  Popconfirm,
  Row,
  Select,
  Skeleton,

} from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import {
  AddEmployeeLicense,
  GetDeviceList,
  GetEmployeeDesignationCategoryById,
  GetEmployeeList,
  GetLicenseManagementSoftwares,
  axiosErrorMessages
} from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import { DeleteOutlined } from "@ant-design/icons";
import AddSoftware from "./AddSoftware";
import { useAppRole } from "../../../API/RoleContext";
import { Backdrop, CircularProgress } from "@mui/material";
import axios, { AxiosError } from "axios";
interface Software {
  softwareName: string;
  version: string;
}

interface SoftwareId {
  softwareId: string;
  versionId: string;
}

interface Employee {
  employeeId: string;
  employeeAssets: EmployeeAsset[];
}

interface EmployeeAsset {
  deviceTypeId: number;
  assetTagId: string;
  os: number;
  osVersion: number[];
  assetSoftware: AssetSoftware[];
}

interface AssetSoftware {
  softwareId: number;
  versionId: number[];
}
interface AddEmployeeLicenseVersion {
  closeAddPopup: (data: any) => void;
}
const AddEmployee: React.FC<AddEmployeeLicenseVersion> = ({
  closeAddPopup,
}) => {
  const appRole = useAppRole();

  const isEdit:boolean = false
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [deviceList, setDeviceList] = useState<{label:string,value:number}[]>([]);
  const [designationCategory, setDesignationCategory] = useState<string>("");
  const [addLicenseForm] = Form.useForm();
  const [softwareList, setSoftwareList] = useState([]);
  const [isAddSoftware, setIsAddSoftware] = useState<boolean>(false);
  const [isOpen, setIsopen] = useState<boolean>(true);
const [hideAddDevice,setHideAddDevice] = useState<boolean>(false)
  const [selectedSoftwareList, setSelectedSoftwareList] = useState<Software[]>(
    []
  );
  const [selectedSoftwareListId, setSelectedSoftwareListId] = useState<any>([]);
  useEffect(() => {
    fetchEmployeeList();
    GetDeviceTypeList();
    GetOsList();
  }, []);
  const onAddNewSoftware = async () => {
    setIsAddSoftware(true);
  };
  const GetOsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicenseManagementSoftwares();

      setSoftwareList(response.data);
      setIsLoading(false);
    } catch (error:any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar("Error in fetching data", {
      //   variant: "error",
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };

  const GetDeviceTypeList = async () => {
    try {
      setIsLoading(true);
      const response = await GetDeviceList();
      const newData = response.data.map((device: any, index: number) => ({
        label: device.deviceType,
        value: device.deviceTypeId,
      }));
      // Remove items with deviceType equal to "Server"
      const filteredDevices: {label:string,value:number}[] = newData.filter((device:{label:string,value:number}) => device.label  !== "Server");

      setDeviceList(filteredDevices);
      setIsLoading(false);
    } catch (error:any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar("Error in fetching data", {
      //   variant: "error",
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };
  const fetchEmployeeList = async () => {
    try {
      setIsLoading(true);
      const response = await GetEmployeeList();
      const newData = response.data.map((employee: any, index: number) => ({
        value: employee.employeeId,
        label: employee.employeeName,
      }));
      setEmployeeList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar(error, {
      //   variant: "error",
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };

  type FieldType = {
    employeeId?: string;
    device?: number;
    assetTagId: string;
  };
  const onClosePopup = () => {
    setIsopen(false);
    closeAddPopup(true);
  };
  const onSelectEmployee = async (event: any) => {
    //api call to get the employee category
    try {
      setIsLoading(true);
      const response = await GetEmployeeDesignationCategoryById(event);
      setDesignationCategory(response.data);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  const onSaveStatusHandler = (formData: any) => {
    setIsLoading(true)
    if(designationCategory) {
 // Update the state with the new software entry
 if(selectedSoftwareList.length > 0) {
  if(formData.employeeAssets[0].assetTagId.trim())  {
    const updatedState = {
      ...formData,
      employeeAssets: [
        ...formData.employeeAssets.map((asset: any) => ({
          ...asset,
          assetSoftware: selectedSoftwareListId,
        })),
      ],
      appRole:appRole
    };
      AddEmployeeLicense(updatedState)
      .then((response: any) => {
        enqueueSnackbar("Added Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false)
  
        closeAddPopup(true);
      })
      .catch((error: any) => {if(error.response.data.errors.License[0]){
        enqueueSnackbar(error.response.data.errors.License[0], {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }else {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
     
        setIsLoading(false)
  
      });
  }else 
  enqueueSnackbar("Enter Device Asset Tag ID", {
    variant: "error",
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  });

} else
enqueueSnackbar("Select License Softwares", {
  variant: "error",
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
});
setIsLoading(false)


    }else
    enqueueSnackbar("Employee dont have designation category", {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    setIsLoading(false)

  };

  const onClose = () => setIsAddSoftware(false)
  const populateListData = (formData: any) => {
    setIsAddSoftware(false);
    const result: any = getSoftwareAndVersion(formData);
    // Use the spread operator to create a new array with the existing items and the new software

 
    const uniqueArray: Software[] = removeDuplicates([
      ...selectedSoftwareList,
      result,
    ]);
setSelectedSoftwareListId(removeDuplicateIds([...selectedSoftwareListId,formData]))
    // Update the state with the new array
    // setSelectedSoftwareListId(
    //   Array.from(new Set([...selectedSoftwareListId, formData]))
    // );
    setSelectedSoftwareList(uniqueArray);
  };
  const removeDuplicateIds = (arr: any) => {
    const uniqueMap = new Map<string, SoftwareId>();
    arr.forEach((software: any) => {
      const key = `${software.softwareId}_${software.versionId}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  const removeDuplicates = (arr: any) => {
    const uniqueMap = new Map<string, Software>();
    arr.forEach((software: any) => {
      const key = `${software.softwareName}_${software.version}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  // Function to get software name and version based on softwareId and versionId
  const getSoftwareAndVersion = (formData: {
  isos:boolean;

    softwareId: number;
    versionId: number;
  }) => {
    const software: any = softwareList.find(
      (item: any) => item.softwareId === formData.softwareId
    );
    if (software) {
      const version = software.versions.find(
        (v: any) => v.versionId === formData.versionId
      );

      if (version) {
        return {
          softwareName: software.softwareName,
          version: version.version,
          isOs: software.isOs
        };
      }
    }

    return undefined;
  };
  const removeItem = (rowData: any, index: number) => {
    const updatedSoftwareList = selectedSoftwareList.filter(
      (software: any) =>
        !(
          software.softwareName === rowData.softwareName &&
          software.version === rowData.version
        )
    );
    const newArray = selectedSoftwareListId.filter((_: any, index: number) => index !== index);

    setSelectedSoftwareListId(newArray);
    // setSelectedSoftwareListId(selectedSoftwareListId.splice(index, 1));

    setSelectedSoftwareList(updatedSoftwareList);
  };
  const filterOption = (
    input: string,
    option?: { label: string; value: number }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <>
      <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      <Modal
        maskClosable={false}
        footer={null}
        title="Add License Provision"
        onCancel={onClosePopup}
        open={isOpen}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 24 }}
          style={{ maxWidth: 1000 }}
          onFinish={onSaveStatusHandler}
          autoComplete="off"
          form={addLicenseForm}
        >
           <Row gutter={16} style={{marginTop: "20px"}}>
              <Col className="gutter-row" lg={12} sm={24}>
          <Form.Item<FieldType>
            rules={[{ required: true, message: "Enter Name" }]}
            name="employeeId"
          >
            <Select
              style={{ width: "100%" }}
              placeholder="Select Employee"
              options={employeeList}
              filterOption={filterOption}
              showSearch
              onSelect={onSelectEmployee}
            />
          </Form.Item>
          </Col>
              <Col className="gutter-row pm-search-flex" lg={12} sm={24}>
              <div style={{paddingLeft: "10px"}}>
            <h3 style={{margin: "0"}}>{designationCategory}</h3>
          </div>
              </Col>
            </Row>
          <Form.List name="employeeAssets">
            {(fields, { add, remove }) => (
              <div
                style={{ display: "flex", rowGap: 16, flexDirection: "column" }}
              >
                {fields.map((field) => (
                  <Card
                    size="small"
                    title={`Device ${field.name + 1}`}
                    key={field.key}
                    extra={
                      <CloseOutlined
                        onClick={() => {
                          setHideAddDevice(false)
                          remove(field.name);
                        }}
                      />
                    }
                  >
                    <Form.Item
                      rules={[{ required: true, message: "Enter Name" }]}
                      label="Device"
                      name={[field.name, "deviceTypeId"]}
                    >
                      <Select
                        options={deviceList}
                        filterOption={filterOption}
                        showSearch
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[{ required: true, message: "Enter Name" }]}
                      label="Asset Tag Id"
                      name={[field.name, "assetTagId"]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 24 }} >
                    <Button
                      type="text"
                      // shape="round"
                      onClick={onAddNewSoftware}
                      icon={<PlusOutlined />}
                    >
                      Add Software
                    </Button>
</Form.Item>
                    <List
                      size="small"
                      className="demo-loadmore-list"
                      itemLayout="horizontal"
                      dataSource={selectedSoftwareList}
                      renderItem={(item: any, index) => (
                        <List.Item
                          actions={[
                            <>
                              <Popconfirm
                                title="Do you want to remove the software?"
                                onConfirm={() => removeItem(item, index)}
                              >
                                <a>
                                  {" "}
                                  <DeleteOutlined />
                                </a>
                              </Popconfirm>
                            </>,
                          ]}
                        >
                          <Skeleton
                            avatar
                            title={false}
                            loading={item.loading}
                            active
                          >
                            <List.Item.Meta title={item.softwareName} />

                            <List.Item.Meta title={item.version} />
                          </Skeleton>
                        </List.Item>
                      )}
                    />
                  </Card>
                ))}
                {!hideAddDevice &&   <Button type="dashed"
 onClick={() => {add(); setHideAddDevice(true)}} block>
                  + Add Device
                </Button>}
              
              </div>
            )}
          </Form.List>

          <Button className="pm-btn"  style={{marginTop:'10px'}} type="primary" htmlType="submit">
            Save
          </Button>
        </Form>
      </Modal>

      {isAddSoftware && <AddSoftware softwareId={0} versionId={0} isEdit={isEdit} onClose={onClose} populateListData={populateListData} editSoftwareDetails={undefined} />}
    </>
  );
};

export default AddEmployee;
